import baseUrl from './baseUrl';

let uri = 'https://demoapi.giztix.com';
if (baseUrl === 'https://api.giztix.com') {
	uri = 'https://giztixgps.giztix.com';
}

export default uri;
